<ng-container
  *ngLet="{
    isSelectingPlan: (isSelectingPlan$ | async),
    selectedPlan: (selectedPlan$ | async),
    plans: (plans$ | async),
    isAnnual: (isAnnual$ | async),
    isFrequencyToggleAvailable: (isFrequencyToggleAvailable$ | async),
    mode: (mode$ | async)
  } as data"
>
  <ng-container *ngIf="data.mode === UpgradePlanListMode.Plans">
    <div class="upgrade-plan-list">
      <div
        class="upgrade-plan-list-header"
        *ngIf="data.isFrequencyToggleAvailable"
      >
        <div class="upgrade-plan-list-frequency">
          <span
            class="upgrade-plan-list-frequency-label"
            [class.upgrade-plan-list-frequency-label-active-monthly]="
              !data.isAnnual
            "
            >Monthly</span
          >
          <mat-slide-toggle
            [checked]="data.isAnnual"
            (change)="onIsAnnualChange($event)"
            class="upgrade-plan-list-frequency-toggle"
          ></mat-slide-toggle>
          <span
            class="upgrade-plan-list-frequency-label"
            [class.upgrade-plan-list-frequency-label-active-annual]="
              data.isAnnual
            "
            >Annual</span
          >
        </div>
        <button class="upgrade-plan-list-header-button">
          <span>Subscribe annually to save 20%</span>
          <span>↓</span>
        </button>
      </div>

      <div class="upgrade-plans-scroll">
        <div class="upgrade-plans">
          <div class="upgrade-plan-card">
            <div class="upgrade-plan-card-header"></div>
            <div
              *ngFor="let feature of features$ | async"
              class="upgrade-plan-card-feature-title"
              [class.high]="feature.high"
            >
              <span [class.bold]="feature.bold">{{ feature.label }}</span>
            </div>
          </div>

          <div
            *ngFor="let plan of data.plans"
            class="upgrade-plan-card"
            [class.upgrade-plan-card-selected]="data.selectedPlan === plan.type"
            [class.upgrade-plan-card-action]="isAvailableUpgrade(plan)"
            (click)="selectSelectPlan(plan)"
          >
            <div class="upgrade-plan-card-header">
              <span class="upgrade-plan-card-header-title">
                {{ plan.type }}
              </span>

              <div
                *ngIf="plan.isCurrent"
                class="upgrade-plan-card-header-badge"
              >
                Current
              </div>
            </div>

            <div class="upgrade-plan-card-features">
              <div
                *ngFor="let feature of features$ | async"
                class="upgrade-plan-card-feature-title"
                [class.high]="feature.high"
              >
                <!-- Mobile feature label -->
                <span class="mobile-label" [class.bold]="feature.bold">{{
                  feature.label
                }}</span>
                <!-- Feature value representation -->
                <span
                  class="feature-value"
                  *ngIf="plan.features[feature.value] === true"
                  ><i class="fa-solid fa-circle-check"></i>
                </span>
                <span
                  class="feature-value"
                  *ngIf="plan.features[feature.value] === false"
                  ><i class="fa-solid fa-circle-xmark"></i>
                </span>
                <span
                  class="feature-value bold"
                  *ngIf="!isBoolean(plan.features[feature.value])"
                >
                  {{ plan.features[feature.value] }}
                </span>
              </div>
            </div>

            <div
              class="upgrade-plan-card-footer"
              *ngIf="isAvailableUpgrade(plan)"
            >
              <mat-checkbox
                [(ngModel)]="termsAccepted"
                class="upgrade-plan-card-footer-checkbox"
                *ngIf="plan.type === SubscriptionPlan.Complete"
              >
                <div>
                  By subscribing to the Complete Plan, you are agreeing to our
                  <a
                    class="upgrade-plan-card-footer-checkbox-link"
                    href=""
                    (click)="openTermsModal($event)"
                    >Terms & Conditions</a
                  >.
                </div>
              </mat-checkbox>

              <button
                mat-button
                [disabled]="isActionDisabled(plan)"
                class="upgrade-plan-card-footer-button"
                (click)="selectPlan(plan)"
              >
                {{ plan.actionText }}

                <mat-spinner
                  *ngIf="data.isSelectingPlan === plan.type"
                  [diameter]="15"
                ></mat-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="data.mode === UpgradePlanListMode.Address">
    <koa-upgrade-plan-address
      [selectedPatient]="selectedPatient$ | async"
      (back)="setMode(UpgradePlanListMode.Plans)"
      (upgradePlan)="upgradeToCompletePlan()"
    ></koa-upgrade-plan-address>
  </ng-container>
</ng-container>
